import { type DiskSpaceLowPayload } from '@heidi/plugin-core';
import { atom } from 'jotai';

/** First accepted low-disk warning for the active capture in this renderer. */
export const lowDiskSpaceAtom = atom<DiskSpaceLowPayload | undefined>(undefined);

/**
 * Rejects delayed events emitted before the current capture started. It stays
 * unchanged across a device restart because that restart retains the same
 * logical capture.
 */
export const lowDiskSpaceAcceptedAfterTsAtom = atom(0);
